<template lang="html">
  <div class="maintenance">
    <img src="@/assets/images/503-image.svg" class="maintenance__image" />

    <h1 class="maintenance__header">
      Revenim imediat!
    </h1>

    <p class="maintenance__message">
      Platforma este în mentenanță
      <!-- {{ message || 'Platforma este în mentenanță'}} -->
    </p>
  
    <UiButton class="maintenance__refresh" name="Reîncarcă pagina" @click="reload" />

    <div style="display: block; width: 100%; height: 70px" />
  </div>
</template>

<script>
import UiButton from '@/components/ui/Button';
import { mapGetters } from 'vuex';

export default {
  components: { UiButton },
  computed: {
    ...mapGetters({
      message: 'notification/title',
    }),
  },
  methods: {
    reload() {
      location.reload();
    },
  }
}
</script>

<style lang="scss" scoped>
@import  "@/scss/pages/maintenance.scss";
</style>
